import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { InfoIconCircle } from '@/assets/icons/info-circle';
import { HowItWorksSteps, getPromotionStepContents } from '@/components/HowItWorksSteps';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { ActiveReferral, ActiveReferrals } from '@/feature/invite-friends/components/ActiveReferrals';
import { GambleResponsibly } from '@/feature/invite-friends/components/GambleResponsibly';
import { TermsAndConditions } from '@/feature/invite-friends/components/TermsAndConditions';
import { RafWithTheme } from '@/feature/invite-friends/hooks/use-raf';
import { DetailsSection } from '@/feature/promohub/components/DetailsSection';
import { isFilled } from '@prismicio/client';

type RafPageContentProps = {
    data?: RafWithTheme;
};
export const RafPageContent = ({ data }: RafPageContentProps) => {
    const { t } = useTranslation('raf');
    const rafContent = data?.data;
    const steps = rafContent?.sender_steps;
    const howItWorksSteps = getPromotionStepContents(steps);
    const termsConditionsLink = rafContent?.tc_link;
    const isEligible = false; // let the disclaimer shown for now
    const activeReferrals: ActiveReferral[] = [];

    return (
        <Box
            paddingHorizontal={'s16'}
            paddingBottom={'s32'}
            backgroundColor={ds.colorToken.background.neutral.base}
            flex={1}
        >
            {activeReferrals.length > 0 ? (
                <Box marginTop={'s24'}>
                    <Text variant={'headlineMedium'}>
                        {t('active_referrals')} ({activeReferrals.length})
                    </Text>
                </Box>
            ) : null}
            <>
                {isEligible ? null : (
                    <Row
                        padding={'s16'}
                        borderWidth={1}
                        style={styles.banner}
                        backgroundColor={ds.colorToken.background.neutral.subtler}
                        borderRadius={'r16'}
                        alignItems={'center'}
                        marginTop={'s24'}
                    >
                        <InfoIconCircle color={ds.colorValue.icon.primary} width={24} height={24} />
                        <Text variant={'bodySmall'} marginLeft={'s16'}>
                            {rafContent?.sender_requirements_disclaimer_text}
                        </Text>
                    </Row>
                )}
                {activeReferrals.length > 0 ? (
                    <Box marginTop={'s20'} marginBottom={'s36'}>
                        <ActiveReferrals activeReferrals={activeReferrals} steps={rafContent?.active_referrals_steps} />
                    </Box>
                ) : (
                    <>
                        <SizedBox value={34} />
                        {howItWorksSteps ? (
                            <HowItWorksSteps steps={howItWorksSteps} title={rafContent?.sender_steps_title} />
                        ) : null}
                    </>
                )}
            </>
            {rafContent?.sender_details_text ? <DetailsSection details={rafContent?.sender_details_text} /> : null}
            {isFilled.link(termsConditionsLink) && !!termsConditionsLink.url ? (
                <TermsAndConditions link={termsConditionsLink.url} />
            ) : null}
            <SizedBox value={80} />
            <GambleResponsibly />
        </Box>
    );
};

const styles = StyleSheet.create({
    banner: {
        borderColor: ds.colorValue.border.subtle,
    },
});
